import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { envInstructions } from "../../utils/utils";
import SpinnerStatus from "../spinner_status/spinner_status";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import { ReactComponent as SuccessCheck } from "../../images/successCheck.svg";
//import { ReactComponent as FailureSignal } from "../../images/failureSignal.svg";
import { ReactComponent as ArrowRight } from "../../images/ArrowRight.svg";
import { addRoute } from "../../redux/features/candidate/candidateAuthSlice";


import "./environment.scss";

const checksMsgs = [
  "Noise Check",
  "Browser Check",
  "Your location is acceptable",
];

const Environment = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  const [scan, setScan] = useState({
    loading: true,
    success: false,
    error: false,
  });
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  //const handleShow = () => setShow(true);
  const handleProceed = () => {
    const path="/instruction"
    dispatch(addRoute(path));
    if (scan.success){ 
      history.push(path);
    }
  };

  useEffect(() => {
    const loadTimeOut = setTimeout(() => {
      setScan((values) => ({
        ...values,
        success: true,
      }));
      setShow(true);
    }, 6000);

    return () => {
      clearTimeout(loadTimeOut);
    };
  }, []);

  return (
    <>
      <div className="environment-container bg-white">
        <div className="title border-bottom p-3 ">
          <h6 className="fw-bold text-primary mb-0">Environment</h6>
        </div>
        <div className="px-4 py-5 border-bottom">
          <div className="d-flex flex-column">
            <h6 className="text-secondary fst-italic">
              Remain patient and quiet as we verify examinaton environment...
            </h6>
            <h6 className="fw-bold mb-4">
              you’re adviced to comply strictly with the following
            </h6>
            {envInstructions.map((text) => (
              <div key={text} className="d-flex flex-row mb-3 align-items-center">
                <ArrowRight />
                <p className="ms-3 mb-0 pt-1 text-info">{text}</p>
              </div>
            ))}
          </div>

          <div className="mt-5 d-flex flex-row mb-3 align-items-center">
            <div
              className="spinner-border text-success"
              style={{ width: "3rem", height: "3rem" }}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="text-info mb-0 ms-3">
              this would only take few minutes...
            </p>
          </div>
        </div>

        <div className="py-4">
          <div className="d-flex justify-content-end px-4"></div>
        </div>
      </div>

      <div>
        <Modal
          className=""
          show={show}
          backdrop="static"
          keyboard={false}
          onHide={handleClose}
          centered
        >
          <div className="d-flex flex-column justify-content-center align-items-center p-4">
            <SuccessCheck className="pb-3" />
            <h5 className="">Check Completed!</h5>
            <p className="mb-4">
              your examination environment has been checked and is acceptable.
            </p>
            <div className="bg-gray-100 d-flex flex-column justify-content-center align-items-center py-3 px-2 w-100 mb-4">
              {checksMsgs.map((check) => (
                <div key={check} className="d-flex mb-2 flex-row justify-content-start w-100 align-items-center">
                  <SpinnerStatus className="small" status={"success"} />{" "}
                  <p className="text-info mb-0 ms-2">{check}</p>
                </div>
              ))}
            </div>
            <Button
              variant="success"
              className="text-white"
              onClick={handleProceed}
            >
              Proceed
            </Button>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default Environment;
